(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yu-product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const tag = 'yu-product-gallery';
  if (customElements.get(tag)) return;

  // The theme scrolls .page-wrapper on desktop. Preserve its scroll position
  // and inline styles rather than changing global page behaviour permanently.
  let lockCount = 0;
  let scrollRecords = [];
  function lockPage() {
    if (lockCount++ > 0) return;
    const nodes = [document.documentElement, document.body, document.querySelector('.page-wrapper')].filter(Boolean);
    scrollRecords = nodes.map(node => ({ node, value: node.style.getPropertyValue('overflow'), priority: node.style.getPropertyPriority('overflow'), top: node.scrollTop, left: node.scrollLeft }));
    nodes.forEach(node => node.style.setProperty('overflow', 'hidden', 'important'));
  }
  function unlockPage() {
    if (lockCount === 0 || --lockCount > 0) return;
    scrollRecords.forEach(({ node, value, priority, top, left }) => {
      if (value) node.style.setProperty('overflow', value, priority);
      else node.style.removeProperty('overflow');
      node.scrollTop = top;
      node.scrollLeft = left;
    });
    scrollRecords = [];
  }

  /* Desktop description-first scrolling.
     CSS does the scrolling; these observers only measure header/gallery sizes.
     No wheel handlers, nested scroll box, fixed-position photos or image resizing. */
  const descriptionScrollOwners = new WeakMap();
  function attachDescriptionFirstScroll(gallery) {
    const noop = () => {};
    if (!document.body.classList.contains('template-product')) return noop;
    const media = gallery.closest('.product-information__media');
    const grid = media?.parentElement;
    if (!grid?.matches('.product-information__grid')) return noop;
    const details = Array.from(grid.children).find(node => node.matches('.product-details'));
    const stage = gallery.querySelector('[data-yu-stage]');
    if (!details || !stage || !window.ResizeObserver) return noop;

    // A variant/editor update can briefly mount two galleries in one column.
    descriptionScrollOwners.get(grid)?.();
    const desktop = window.matchMedia('(min-width: 990px)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const header = document.getElementById('header-component');
    const oldTop = media.style.getPropertyValue('--yu-photo-sticky-top');
    const oldPriority = media.style.getPropertyPriority('--yu-photo-sticky-top');
    let disposed = false;
    let frame = 0;
    let observedScroller = null;
    const gapBelowHeader = 24;
    const gapBelowGallery = 24;

    function restore() {
      grid.removeAttribute('data-yu-description-first');
      if (oldTop) media.style.setProperty('--yu-photo-sticky-top', oldTop, oldPriority);
      else media.style.removeProperty('--yu-photo-sticky-top');
    }

    function findScrollport() {
      // On this theme desktop scrolls .page-wrapper, not window.
      // Find the real ancestor rather than assuming a particular scroll element.
      for (let node = grid.parentElement; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
        if (/^(auto|scroll|overlay|hidden)$/.test(getComputedStyle(node).overflowY)) return node;
      }
      return document.scrollingElement || document.documentElement;
    }

    function schedule() {
      if (!disposed && !frame) frame = requestAnimationFrame(measure);
    }

    function measure() {
      frame = 0;
      if (disposed || !gallery.isConnected) return;
      if (!desktop.matches) {
        restore();
        return;
      }
      grid.setAttribute('data-yu-description-first', '');
      const scroller = findScrollport();
      if (scroller !== observedScroller) {
        if (observedScroller) observer.unobserve(observedScroller);
        observedScroller = scroller;
        observer.observe(scroller);
      }
      const rootScroll = scroller === document.scrollingElement || scroller === document.documentElement;
      const scrollTopEdge = rootScroll ? 0 : scroller.getBoundingClientRect().top + scroller.clientTop;
      const scrollHeight = rootScroll ? document.documentElement.clientHeight : scroller.clientHeight;
      const mediaRect = media.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      if (!scrollHeight || !mediaRect.height || !stageRect.width) return;

      const headerRect = header?.getBoundingClientRect();
      const headerOverlap = headerRect && headerRect.bottom > scrollTopEdge && headerRect.top <= scrollTopEdge + 1
        ? Math.min(scrollHeight, headerRect.bottom - scrollTopEdge)
        : 0;
      // Include the existing gallery padding without changing it.
      const innerTopSpace = stageRect.top - mediaRect.top;
      const topAligned = headerOverlap + gapBelowHeader - innerTopSpace;
      // A tall gallery may need to scroll a little first so its thumbnails are
      // reachable. This adjusts only its sticky offset, never its dimensions.
      const bottomAligned = scrollHeight - mediaRect.height - gapBelowGallery;
      const stickyTop = Math.min(topAligned, bottomAligned);
      const value = `${Math.round(stickyTop * 100) / 100}px`;
      if (media.style.getPropertyValue('--yu-photo-sticky-top') !== value) {
        media.style.setProperty('--yu-photo-sticky-top', value);
      }
    }

    const observer = new ResizeObserver(schedule);
    [media, details, grid, stage, header].filter(Boolean).forEach(node => observer.observe(node));
    desktop.addEventListener('change', schedule, options);
    window.addEventListener('resize', schedule, { ...options, passive: true });
    window.addEventListener('pageshow', schedule, options);
    if (document.fonts?.ready) document.fonts.ready.then(schedule).catch(() => {});

    function cleanup() {
      if (disposed) return;
      disposed = true;
      cancelAnimationFrame(frame);
      observer.disconnect();
      controller.abort();
      if (descriptionScrollOwners.get(grid) === cleanup) {
        restore();
        descriptionScrollOwners.delete(grid);
      }
    }
    descriptionScrollOwners.set(grid, cleanup);
    measure();
    return cleanup;
  }

  class YuProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialise()) return;
      this.childObserver = new MutationObserver(() => {
        if (this.initialise()) this.childObserver.disconnect();
      });
      this.childObserver.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.releaseDescriptionScroll?.();
      this.releaseDescriptionScroll = null;
      this.childObserver?.disconnect();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.railObserver?.disconnect();
      this.navigationQueue = [];
      this.navigationBusy = false;
      this.railAnimation?.cancel();
      this.railAnimation = null;
      this.resetRail(this.index || 0);
      clearTimeout(this.preloadTimer);
      this.operation = (this.operation || 0) + 1;
      this.viewerOperation = (this.viewerOperation || 0) + 1;
      this.fade?.cancel();
      if (this.dialog?.open) this.dialog.close();
      this.releaseScroll();
      this.ready = false;
    }

    initialise() {
      if (this.ready) return true;
      const stage = this.querySelector('[data-yu-stage]');
      const toolbar = this.querySelector('[data-yu-toolbar]');
      const status = this.querySelector('[data-yu-status]');
      const dialog = this.querySelector('[data-yu-viewer]');
      if (!stage || !toolbar || !status) return false;
      if (this.dataset.enlarge === 'true' && (!dialog || !dialog.querySelector('[data-yu-viewer-image]') || !dialog.querySelector('[data-yu-viewer-scroll]') || !dialog.querySelector('[data-yu-close]') || !dialog.querySelector('[data-yu-viewer-status]'))) return false;
      this.stage = stage;
      this.toolbar = toolbar;
      this.status = status;
      this.dialog = dialog;
      this.slides = Array.from(stage.querySelectorAll('[data-yu-slide]'));
      if (!this.slides.length) return false;
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.requestedIndex = this.index;
      this.operation = (this.operation || 0) + 1;
      this.viewerOperation = (this.viewerOperation || 0) + 1;
      this.thumbnails = Array.from(this.querySelectorAll('[data-yu-index]'));
      this.thumbStrip = this.querySelector('[data-yu-thumbnails]');
      this.thumbTrack = this.querySelector('[data-yu-track]');
      this.navigation = this.querySelector('.yu-gallery__navigation');
      if (this.slides.length > 1 && (!this.thumbStrip || !this.thumbTrack || this.thumbnails.length !== this.slides.length)) return false;
      this.visibleCount = Math.min(5, this.slides.length);
      this.navigationQueue = [];
      this.navigationBusy = false;
      this.openLink = this.querySelector('[data-yu-open]');
      this.message = this.querySelector('[data-yu-message]');
      this.viewerImage = this.querySelector('[data-yu-viewer-image]');
      this.viewerScroll = this.querySelector('[data-yu-viewer-scroll]');
      this.viewerStatus = this.querySelector('[data-yu-viewer-status]');
      this.zoomButton = this.querySelector('[data-yu-zoom]');
      this.duration = Math.min(2000, Math.max(0, Number(this.dataset.duration) || 0));
      this.railDuration = Math.min(2000, Math.max(0, Number(this.dataset.thumbnailDuration) || 0));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.loads = new WeakMap();

      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-yu-index], [data-yu-previous], [data-yu-next], [data-yu-expand], [data-yu-open], [data-yu-close], [data-yu-zoom]');
        if (!button || button.closest(tag) !== this) return;
        // A swipe must not also activate the thumbnail beneath the released finger.
        if ((button.hasAttribute('data-yu-open') || button.hasAttribute('data-yu-index')) && Date.now() < (this.suppressOpenUntil || 0)) {
          event.preventDefault(); return;
        }
        if (button.hasAttribute('data-yu-index')) {
          event.preventDefault();
          if (button.hasAttribute('data-yu-clone')) return;
          let offset;
          if (event.detail > 0) {
            // Use the fixed SLOT, not the photograph moving under the pointer.
            // Repeated clicks in slot 2 therefore queue one forward step each.
            const rect = this.thumbStrip.getBoundingClientRect();
            const step = this.thumbnailStep();
            offset = Math.max(0, Math.min(this.visibleCount - 1, Math.floor((event.clientX - rect.left) / step)));
          } else {
            const order = Array.from(this.thumbTrack.querySelectorAll('[data-yu-index]:not([data-yu-clone])'));
            offset = order.indexOf(button);
          }
          if (offset > 0) this.enqueueNavigation({ delta: offset, fromThumbnail: true });
        }
        else if (button.hasAttribute('data-yu-previous')) { event.preventDefault(); this.step(-1); }
        else if (button.hasAttribute('data-yu-next')) { event.preventDefault(); this.step(1); }
        else if (button.hasAttribute('data-yu-close')) { event.preventDefault(); this.dialog.close(); }
        else if (button.hasAttribute('data-yu-zoom')) { event.preventDefault(); this.toggleZoom(); }
        else if (this.dialog && typeof this.dialog.showModal === 'function') {
          event.preventDefault(); this.openViewer(button);
        }
      }, options);

      this.addEventListener('keydown', event => {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
        if (!(event.target instanceof Element) || event.target.closest(tag) !== this) return;
        if (this.dialog?.open && this.viewerScroll?.classList.contains('is-zoomed') && event.target === this.viewerScroll) return;
        let action = null;
        if (event.key === 'ArrowRight') action = { delta: 1 };
        if (event.key === 'ArrowLeft') action = { delta: -1 };
        if (event.key === 'Home') action = { index: 0 };
        if (event.key === 'End') action = { index: this.slides.length - 1 };
        if (!action || this.slides.length < 2) return;
        event.preventDefault();
        action.fromThumbnail = !!event.target.closest('[data-yu-index]');
        this.enqueueNavigation(action);
      }, options);

      this.bindSwipe(stage, options, () => true);
      if (this.thumbStrip) this.bindSwipe(this.thumbStrip, options, () => true);
      if (this.viewerScroll) this.bindSwipe(this.viewerScroll, options, () => !this.viewerScroll.classList.contains('is-zoomed'));
      if (this.dialog) {
        this.dialog.addEventListener('close', () => {
          this.viewerOperation++;
          this.resetZoom();
          this.releaseScroll();
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
      }
      this.resizeObserver = new ResizeObserver(() => {
        if (this.dialog?.open) this.resetZoom();
      });
      this.resizeObserver.observe(this.stage);
      if (this.thumbStrip) {
        this.railObserver = new ResizeObserver(() => this.measureRail());
        this.railObserver.observe(this.thumbStrip);
      }
      this.reducedMotion.addEventListener('change', () => {
        if (!this.reducedMotion.matches) return;
        try { this.fade?.finish(); this.railAnimation?.finish(); } catch (_) { /* Already finished. */ }
      }, options);

      this.toolbar.hidden = this.slides.length < 2 && !this.dialog;
      this.ready = true;
      this.settleSlides();
      this.measureRail();
      this.resetRail(this.index);
      this.updateControls(false);
      this.preloadNeighbours();
      this.releaseDescriptionScroll = attachDescriptionFirstScroll(this);
      return true;
    }

    wrap(index) { return (index + this.slides.length) % this.slides.length; }
    step(delta) {
      if (this.slides.length > 1) this.enqueueNavigation({ delta });
    }

    select(index) {
      if (Number.isInteger(index)) this.enqueueNavigation({ index });
    }

    enqueueNavigation(action) {
      if (!this.ready || this.slides.length < 2) return;
      // A small queue preserves quick repeated clicks without interrupting a slide.
      // Bound it so accidental double-click bursts cannot run for minutes.
      if (this.navigationQueue.length >= 8) return;
      this.navigationQueue.push(action);
      if (!this.navigationBusy) this.drainNavigation();
    }

    async drainNavigation() {
      if (this.navigationBusy || !this.ready) return;
      this.navigationBusy = true;
      this.toolbar.setAttribute('aria-busy', 'true');
      const generation = this.operation;
      try {
        while (this.isConnected && this.ready && generation === this.operation && this.navigationQueue.length) {
          const action = this.navigationQueue.shift();
          let delta = action.delta;
          if (!Number.isInteger(delta)) delta = this.wrap(action.index - this.index);
          if (!delta || this.wrap(delta) === 0) continue;
          await this.moveGallery(delta, action.fromThumbnail, generation);
        }
      } finally {
        if (generation === this.operation) {
          this.navigationBusy = false;
          this.toolbar.removeAttribute('aria-busy');
          this.stage.removeAttribute('aria-busy');
        }
      }
    }

    measureRail() {
      if (!this.thumbStrip || !this.navigation) return;
      const width = this.thumbStrip.getBoundingClientRect().width;
      if (width <= 0) return;
      const styles = getComputedStyle(this);
      const preferredGap = parseFloat(styles.getPropertyValue('--yu-thumb-gap')) || 12;
      // Keep five complete previews on a narrow phone. Reduce the gap first
      // when necessary; the chosen thumbnail size is the maximum, not a minimum.
      const gap = this.visibleCount > 1
        ? Math.min(preferredGap, Math.max(4, (width - 32 * this.visibleCount) / (this.visibleCount - 1)))
        : 0;
      const size = Math.max(1, (width - gap * (this.visibleCount - 1)) / this.visibleCount);
      if (Math.abs((this.railWidth || 0) - width) < 0.1 && Math.abs((this.railGap || 0) - gap) < 0.1) return;
      this.railWidth = width;
      this.railGap = gap;
      this.navigation.style.setProperty('--yu-thumb-effective', `${size}px`);
      this.navigation.style.setProperty('--yu-thumb-gap-effective', `${gap}px`);
      // Settle the rail if its pixel geometry changes during an animation.
      try { this.railAnimation?.finish(); } catch (_) { /* Animation already ended. */ }
    }

    thumbnailStep() {
      const button = this.thumbnails?.[0];
      return button ? button.getBoundingClientRect().width + (this.railGap || 0) : 1;
    }

    resetRail(index) {
      if (!this.thumbTrack || !this.thumbnails?.length) return;
      const order = this.thumbnails.map((_, offset) => this.thumbnails[this.wrap(index + offset)]);
      this.thumbTrack.replaceChildren(...order);
      this.thumbTrack.style.removeProperty('transform');
      this.thumbStrip.scrollLeft = 0;
      order.forEach((button, position) => {
        button.tabIndex = position < this.visibleCount ? 0 : -1;
        button.inert = position >= this.visibleCount;
        if (position >= this.visibleCount) button.setAttribute('aria-hidden', 'true');
        else button.removeAttribute('aria-hidden');
      });
    }

    railClone(button) {
      const clone = button.cloneNode(true);
      clone.setAttribute('data-yu-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      clone.inert = true;
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      return clone;
    }

    async animateRail(delta, next, generation) {
      if (!this.thumbTrack) return;
      const duration = this.reducedMotion.matches ? 0 : this.railDuration;
      if (!duration || !this.thumbTrack.animate) {
        this.resetRail(next);
        return;
      }
      const step = this.thumbnailStep();
      const ordered = Array.from(this.thumbTrack.children);
      let from = 0;
      let to = -delta * step;
      if (delta > 0) {
        // Fill the trailing edge before moving. All clones are decorative,
        // inert and removed at the end; never expose duplicate keyboard stops.
        for (let offset = 0; offset < delta; offset++) {
          this.thumbTrack.append(this.railClone(ordered[offset % ordered.length]));
        }
      } else {
        const fragment = document.createDocumentFragment();
        for (let offset = delta; offset < 0; offset++) {
          fragment.append(this.railClone(this.thumbnails[this.wrap(this.index + offset)]));
        }
        this.thumbTrack.prepend(fragment);
        from = delta * step;
        to = 0;
      }
      this.thumbTrack.setAttribute('data-moving', '');
      const animation = this.thumbTrack.animate(
        [{ transform: `translateX(${from}px)` }, { transform: `translateX(${to}px)` }],
        { duration, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'forwards' }
      );
      this.railAnimation = animation;
      try { await animation.finished; } catch (_) { /* Resize/removal can finish or cancel it. */ }
      if (generation !== this.operation || !this.isConnected) return;
      // Reorder at an identical visual position before discarding the animation.
      this.resetRail(next);
      animation.cancel();
      this.railAnimation = null;
      this.thumbTrack.removeAttribute('data-moving');
    }

    bindSwipe(target, options, allowed) {
      let point = null;
      target.addEventListener('pointerdown', event => {
        if (!allowed() || event.pointerType === 'mouse' || !event.isPrimary) { point = null; return; }
        point = { id: event.pointerId, x: event.clientX, y: event.clientY, time: Date.now() };
      }, options);
      target.addEventListener('pointercancel', () => { point = null; }, options);
      target.addEventListener('pointerup', event => {
        if (!point || point.id !== event.pointerId || !allowed()) return;
        const dx = event.clientX - point.x;
        const dy = event.clientY - point.y;
        const elapsed = Date.now() - point.time;
        point = null;
        if (elapsed > 1500 || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        this.suppressOpenUntil = Date.now() + 600;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.step((dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
      }, options);
    }

    loadImage(image) {
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();
      if (this.loads.has(image)) return this.loads.get(image);
      const promise = new Promise((resolve, reject) => {
        let timer;
        let finished = false;
        const finish = async success => {
          if (finished) return;
          finished = true;
          clearTimeout(timer);
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
          if (!success) { this.loads.delete(image); reject(new Error('Image unavailable')); return; }
          try { if (image.decode) await image.decode(); } catch (_) { /* A loaded image can still be displayed. */ }
          resolve();
        };
        const loaded = () => finish(true);
        const failed = () => finish(false);
        image.addEventListener('load', loaded, { once: true });
        image.addEventListener('error', failed, { once: true });
        timer = setTimeout(failed, 12000);
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.complete && image.naturalWidth > 0) loaded();
      });
      this.loads.set(image, promise);
      return promise;
    }

    settleSlides() {
      this.fade?.cancel();
      this.fade = null;
      this.slides.forEach((slide, index) => {
        slide.hidden = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
        slide.style.removeProperty('z-index');
      });
    }

    async moveGallery(delta, fromThumbnail, generation) {
      const next = this.wrap(this.index + delta);
      this.requestedIndex = next;
      this.stage.setAttribute('aria-busy', 'true');
      this.message.hidden = true;
      const incoming = this.slides[next];
      try { await this.loadImage(incoming.querySelector('img')); }
      catch (_) {
        if (generation !== this.operation || !this.isConnected) return;
        this.requestedIndex = this.index;
        this.stage.removeAttribute('aria-busy');
        this.message.textContent = 'This image could not load. Please try again.';
        this.message.hidden = false;
        this.status.textContent = this.message.textContent;
        this.navigationQueue = [];
        return;
      }
      if (generation !== this.operation || !this.isConnected) return;
      const focused = document.activeElement;
      const restoreThumbnailFocus = fromThumbnail && this.thumbTrack?.contains(focused);
      this.settleSlides();
      const outgoing = this.slides[this.index];
      this.thumbnails.forEach(button => {
        if (Number(button.dataset.yuIndex) === next) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      // Start both animations together only after the new main photograph is ready.
      const railFinished = this.animateRail(delta, next, generation);
      this.index = next;
      incoming.hidden = false;
      incoming.setAttribute('aria-hidden', 'false');
      incoming.style.zIndex = '2';
      outgoing.style.zIndex = '1';
      outgoing.setAttribute('aria-hidden', 'true');
      this.updateControls(true);
      if (this.dialog?.open) this.refreshViewer();
      const duration = this.reducedMotion.matches ? 0 : this.duration;
      let fadeFinished = Promise.resolve();
      if (duration > 0 && incoming.animate) {
        this.fade = incoming.animate([{ opacity: 0 }, { opacity: 1 }], { duration, easing: 'ease-out' });
        fadeFinished = this.fade.finished.catch(() => {});
      }
      await Promise.all([railFinished, fadeFinished]);
      if (generation !== this.operation || !this.isConnected) return;
      this.settleSlides();
      this.stage.removeAttribute('aria-busy');
      // DOM reordering can clear keyboard focus. Restore only when the user
      // has not deliberately focused another control while the motion ran.
      if (restoreThumbnailFocus && (document.activeElement === document.body || this.thumbTrack.contains(document.activeElement))) {
        this.thumbnails[next].focus({ preventScroll: true });
      }
      this.preloadNeighbours();
    }

    updateControls(announce) {
      const currentImage = this.slides[this.index].querySelector('img');
      this.thumbnails.forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.openLink) {
        this.openLink.href = this.slides[this.index].dataset.fullSrc;
        this.openLink.setAttribute('aria-label', 'Enlarge ' + currentImage.alt);
      }
      // Thumbnail ordering is handled by the looping rail, never scrollIntoView.
      if (announce) this.status.textContent = `Image ${this.index + 1} of ${this.slides.length}. ${currentImage.alt}`;
    }

    preloadNeighbours() {
      clearTimeout(this.preloadTimer);
      if (this.slides.length < 2 || navigator.connection?.saveData) return;
      this.preloadTimer = setTimeout(() => {
        if (!this.isConnected) return;
        const neighbours = new Set([this.wrap(this.index + 1), this.wrap(this.index - 1)]);
        neighbours.forEach(index => this.loadImage(this.slides[index].querySelector('img')).catch(() => {}));
      }, 400);
    }

    openViewer(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.returnFocus = trigger;
      this.dialog.showModal();
      lockPage();
      this.scrollLocked = true;
      this.querySelector('[data-yu-close]').focus({ preventScroll: true });
      this.refreshViewer();
    }

    releaseScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      unlockPage();
    }

    async refreshViewer() {
      const operation = ++this.viewerOperation;
      const slide = this.slides[this.index];
      const source = slide.querySelector('img');
      this.resetZoom();
      this.viewerImage.alt = source.alt;
      // Keep intrinsic dimensions in sync when the enlarged photograph changes.
      const previewWidth = Number(source.getAttribute('width')) || source.naturalWidth;
      const previewHeight = Number(source.getAttribute('height')) || source.naturalHeight;
      if (previewWidth > 0 && previewHeight > 0) {
        this.viewerImage.width = previewWidth;
        this.viewerImage.height = previewHeight;
      }
      this.viewerImage.src = source.currentSrc || source.src;
      this.viewerStatus.textContent = `Image ${this.index + 1} of ${this.slides.length}. ${source.alt}`;
      const highResolution = new Image();
      highResolution.dataset.src = slide.dataset.fullSrc;
      try { await this.loadImage(highResolution); }
      catch (_) { return; } // Keep the already-loaded preview rather than showing a broken image.
      if (!this.isConnected || operation !== this.viewerOperation || !this.dialog.open) return;
      this.viewerImage.width = highResolution.naturalWidth;
      this.viewerImage.height = highResolution.naturalHeight;
      this.viewerImage.src = highResolution.src;
    }

    resetZoom() {
      if (!this.viewerScroll) return;
      this.viewerScroll.classList.remove('is-zoomed');
      this.viewerImage.style.removeProperty('width');
      this.viewerScroll.scrollTop = 0;
      this.viewerScroll.scrollLeft = 0;
      this.zoomButton.setAttribute('aria-pressed', 'false');
      this.zoomButton.setAttribute('aria-label', 'Zoom in');
    }

    toggleZoom() {
      if (!this.viewerImage?.naturalWidth) return;
      if (this.viewerScroll.classList.contains('is-zoomed')) { this.resetZoom(); return; }
      const fittedWidth = this.viewerImage.getBoundingClientRect().width;
      const desiredWidth = Math.min(this.viewerImage.naturalWidth, fittedWidth * 2);
      if (desiredWidth < fittedWidth + 1) return;
      this.viewerScroll.classList.add('is-zoomed');
      this.viewerImage.style.width = `${desiredWidth}px`;
      this.zoomButton.setAttribute('aria-pressed', 'true');
      this.zoomButton.setAttribute('aria-label', 'Fit image to screen');
      this.viewerScroll.scrollLeft = Math.max(0, (this.viewerScroll.scrollWidth - this.viewerScroll.clientWidth) / 2);
      this.viewerScroll.scrollTop = Math.max(0, (this.viewerScroll.scrollHeight - this.viewerScroll.clientHeight) / 2);
    }
  }

  customElements.define(tag, YuProductGallery);
})();
  } catch(e) { console.error(e); }
})();

})();
